import React from 'react';

const SkylineGroundTram = ({ stroke }) => (
  <>
    {/* GROUND LINE */}
    <line x1="0" y1="276" x2="1600" y2="276" stroke={stroke} strokeWidth="1" strokeOpacity="0.45" />
    <line x1="0" y1="270" x2="1600" y2="270" stroke={stroke} strokeWidth="0.5" strokeOpacity="0.22" strokeDasharray="3 5" />

    {/* TRAM */}
    <g className="cs-tram">
      <g transform="translate(0 254)" stroke={stroke} strokeWidth="1.2" strokeOpacity="0.85" fill={stroke} fillOpacity="0.06">
        <rect x="0" y="0" width="60" height="16" rx="3" />
        <rect x="65" y="0" width="40" height="16" rx="3" />
        {[6, 18, 30, 42, 70, 84, 96].map(x => <rect key={x} x={x} y="3" width="6" height="6" fill="none" strokeOpacity="0.6" />)}
        <circle cx="10" cy="18" r="3" fill={stroke} fillOpacity="0.3" />
        <circle cx="50" cy="18" r="3" fill={stroke} fillOpacity="0.3" />
        <circle cx="72" cy="18" r="3" fill={stroke} fillOpacity="0.3" />
        <circle cx="98" cy="18" r="3" fill={stroke} fillOpacity="0.3" />
        <line x1="105" y1="6" x2="120" y2="2" strokeOpacity="0.55" />
        <line x1="105" y1="10" x2="122" y2="10" strokeOpacity="0.45" />
        <line x1="105" y1="14" x2="120" y2="18" strokeOpacity="0.55" />
      </g>
    </g>

    {/* Rail ties */}
    <g stroke={stroke} strokeOpacity="0.18">
      {Array.from({ length: 120 }, (_, i) => (
        <line key={`city-3-${i}`} x1={i * 14} y1="272" x2={i * 14 + 8} y2="272" strokeWidth="0.6" />
      ))}
    </g>
  </>
);

export default SkylineGroundTram;
